class CreateUserActivationCodeDto {
  activationCode!: string;
}

export default CreateUserActivationCodeDto;
